import React from 'react';
import cx from 'classnames';
import { useSelector } from 'react-redux';

import { getCurrentDialogId } from '../../store/selectors';

import s from './index.module.css';

import MessagesCounter from '../MessagesCounter';
import { ReactComponent as StarIcon } from '../../assets/icons/star.svg';
import UserIcon from '../UserIcon/UserIcon';

import getFormattedDateRU from '../../utils/getFormattedDateRU';

const ExpertDialog = ({
    name,
    rating,
    photoPath,
    dialogTime,
    dialogId,
    carBrand,
    isActive,
    setActiveDialog,
    isOnline,
    unreadMessages
}) => {
    const currentDialogId = useSelector(getCurrentDialogId);
    const handleExpertDialogClick = () => {
        setActiveDialog();
    }
    // Вынести форматирование рейтинга в отдельную функцию
    const numberRatingEmex = rating && Math.round(rating * 10) / 10;
    let displayedRatingEmex = numberRatingEmex?.toString().replace('.', ',');

    if (displayedRatingEmex) {
        if (displayedRatingEmex.indexOf(',') === -1){
            displayedRatingEmex = `${displayedRatingEmex},0`;
        }
    } else {
        displayedRatingEmex = ``;
    }

    if (!name) {
        name = `Поиск эксперта`;
    }

    const formattedDialogTime = dialogTime && getFormattedDateRU(dialogTime).dayMonthRU;
    const isShowMessagesCount = Boolean(unreadMessages) && dialogId !== currentDialogId;

    return (
        <li className={cx(s.expertDialogWrapper,
            { [s.activeDialog]: isActive })}
            onClick={handleExpertDialogClick}
        >
            <div className={s.avatarWrapper}>
                <UserIcon isOnline={isOnline} icon={photoPath} />
            </div>
            
            <div className={s.expertInfo}>
                <div className={s.firstRow}>
                    {name && <span className={s.expertName}>{name}</span>}
                    <div className={s.dialogTime}>{formattedDialogTime}</div>
                </div>
                <div className={s.secondRow}>
                    <div className={s.expertAdditionalInfo}>
                        {displayedRatingEmex && (
                            <div className={s.rating}>
                                <StarIcon className={s.ratingImage} />
                                <span>{displayedRatingEmex}</span>
                            </div>
                        )}
                        {carBrand &&
                            <>
                                <div>&#8226;</div>
                                <div className={s.carBrand}>{carBrand}</div>
                            </>
                        }
                    </div>
                    {isShowMessagesCount && <MessagesCounter count={unreadMessages} />}
                </div>
            </div>
        </li>
    );
};

export default ExpertDialog;
